import { render, staticRenderFns } from "./ImportMain.vue?vue&type=template&id=2a402252"
import script from "./ImportMain.vue?vue&type=script&lang=js"
export * from "./ImportMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports